module.exports = __webpack_public_path__ + "media/images/flags/td-1e912db2751934a80b0ae03ffa3127dc.svg";